import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SlicePipe, DatePipe } from '@angular/common';
import { StarRatingModule } from 'angular-star-rating';

import { TranslateDirective } from '@speedy/core';

import { Review } from '../../interfaces/Review';

@Component({
  selector: 'app-reviews-list',
  templateUrl: './reviews-list.component.html',
  styleUrls: ['./reviews-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [StarRatingModule, TranslateDirective, SlicePipe, DatePipe],
})
export class ReviewsListComponent {
  @Input() reviews: Review[] = [];
  pageNumber = 1;

  _pageSize = 4;
  get pageSize() {
    return this._pageSize * this.pageNumber;
  }
  set pageSize(value: number) {
    this._pageSize = value;
  }

  loadMore(): void {
    this.pageNumber++;
  }
}
